import { makeAutoObservable } from 'mobx';
import {DomainStore} from 'shared/store';

class CompanyLinksState {
  store = new DomainStore();
  emojiReady;

  companyLinks;

  constructor() {
    makeAutoObservable(this, {
      store: false,
      emojiReady: false
    });
  }

  receiveProps({companyLinks, emojiReady}) {
    this.companyLinks = companyLinks;
    this.emojiReady = emojiReady;
  }
}

export default CompanyLinksState;
